import { render, staticRenderFns } from "./PageNotFoundView.vue?vue&type=template&id=3193380a&scoped=true"
import script from "./PageNotFoundView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageNotFoundView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PageNotFoundView.vue?vue&type=style&index=0&id=3193380a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3193380a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3193380a')) {
      api.createRecord('3193380a', component.options)
    } else {
      api.reload('3193380a', component.options)
    }
    module.hot.accept("./PageNotFoundView.vue?vue&type=template&id=3193380a&scoped=true", function () {
      api.rerender('3193380a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PageNotFound/PageNotFoundView.vue"
export default component.exports